export default "<p>file-upload works!</p>\r\n"